export enum HomeTabQuestions {
  BUSINESS_GOALS = 'business_goals',
  WHERE_CUSTOMERS_SUBSCRIBE = 'where_customers_subscribe',
  WHAT_CONTENT = 'what_content',
  ADS_BUDGET = 'ads_budget',
  ADS_EXPERIENCE = 'ads_experience',
}

export enum BUSINESS_GOALS_TYPE {
  SITE_VISITS_OR_REGISTRATIONS = 'site_visits_or_registrations',
  HUMAN_AGENT_OR_BOT_SUPPORT = 'human_agent_or_bot_support',
  ORDERS = 'orders',
  REVIEWS = 'reviews',
  OTHER = 'other',
}

export enum WHERE_CUSTOMERS_SUBSCRIBE_TYPE {
  WEBSITE = 'website',
  FACEBOOK_PAGE = 'facebook_page',
  IMPORT = 'import',
  FACEBOOK_ADS = 'facebook_ads',
  OFFLINE = 'offline',
  DONT_KNOW = 'dont_know',
  OTHER = 'other',
}

export enum WHAT_CONTENT_TYPE {
  WELCOME_SERIES = 'welcome_series',
  COUPONS_AND_DISCOUNTS = 'coupons_and_discounts',
  ABANDONED_TRIGGERS = 'abandoned_triggers',
  NEWSLETTERS_AND_PROMO_CAMPAIGNS = 'newsletters_and_promo_campaigns',
  POST_PURCHASE_MESSAGES = 'post_purchase_messages',
  GENERAL_TRIGGERED_CAMPAIGNS = 'general_triggered_campaigns',
  ORDER_STATUS_UPDATES = 'order_status_updates',
  SEQUENCES = 'sequences',
  PERSONALIZED_UPDATES = 'personalized_updates',
  OTHER = 'other',
}

export enum ADS_BUDGET_TYPE {
  LESS_100 = 'less_100',
  FROM_100_TO_1000 = '100_1000',
  FROM_1000_TO_10000 = '1000_10000',
  FROM_10000_TO_50000 = '10000_50000',
  FROM_50000_TO_100000 = '50000_100000',
  MORE_100000 = 'more_100000',
  NOT_USING_ADS = 'not_using_ads',
}

export enum ADS_EXPERIENCE_TYPE {
  NEVER_WORKED = 'never_worked',
  NO_CTM = 'no_ctm',
  NO_AUTOMATION = 'no_automation',
  USE_CTM_AND_AUTOMATION = 'use_ctm_and_automation',
  OTHER = 'other',
}

export const FACEBOOK_AD_LEADS_SIMPLE_VIDEO_ID = 'xlQ6Xx52myE'
